import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { queries } from '@/apollo';
import { apolloService } from '@/apollo/apolloRequests.ts';
import { useStorage, StorageSerializers } from '@vueuse/core';
import { Query } from '@/generated/graphql';
import { UserAccessLevel, FirmMarketsType } from '@/components/SettingsTeamMembers/types.ts';
import { useUserStore } from '@/store/user';

export const useAccountantInfoStore = defineStore('accountantInfoStore', () => {
  const accountantInfo = useStorage('accountantInfo', null, undefined, { serializer: StorageSerializers.object });

  const isAccountantChiefRole = computed(() => accountantInfo.value?.access === UserAccessLevel.Chief);
  const isAccountantUserRole = computed(() => accountantInfo.value?.access === UserAccessLevel.User);

  const userStore = useUserStore();
  const { isAccountantRole } = storeToRefs(userStore);
  const firmMarkets = computed(() => accountantInfo.value?.firm?.markets as FirmMarketsType);
  const isUserWithElevatedAccess = computed(() => isAccountantChiefRole.value && isAccountantRole.value);

  const clearAccountantInfo = () => {
    accountantInfo.value = [];
  };

  const getAccountantInfo = async () => {
    if (!isAccountantRole.value) return;
    try {
      const data = (await apolloService.makeApolloRequest(
        'query',
        queries.GET_ACCOUNTANT_INFO,
      )) as Query;
      accountantInfo.value = data?.accounting?.accountantInfo[0] || null;
    } catch (error) {
      console.error('Error fetching accounting files:', error);
      throw error;
    }
  };

  return {
    accountantInfo,
    isUserWithElevatedAccess,
    isAccountantChiefRole,
    isAccountantUserRole,
    firmMarkets,
    getAccountantInfo,
    clearAccountantInfo,
  };
});
